import BlanketGhost from '../components/creatives/BlanketGhost';
import Octopus from '../components/creatives/Octopus';

export const creativesRegistry = [
    {
        id: 'blanket-ghost',
        name: 'Smooth Whale',
        slug: 'blanket-ghost',
        component: BlanketGhost,
        description: 'An elegant whale that smoothly follows your cursor with layered animation rendering',
        category: 'Animation'
    },
    {
        id: 'octopus',
        name: 'Octopus',
        slug: 'octopus',
        component: Octopus,
        description: 'An animated octopus with falling tentacles that follow your mouse cursor with physics-based movement',
        category: 'Animation'
    }
    // More creatives can be added here
];

export const getCreativeBySlug = (slug) => {
    return creativesRegistry.find(creative => creative.slug === slug);
};

export default creativesRegistry;
